import { StyleSheet, Text, View } from 'react-native'
import React from 'react'

//components
import HomeDetailsHeader from '../../components/home/HomeDetailsHeader'
import Card from '../../components/shared/card/Card'
import CardSeparator from '../../components/shared/card/CardSeparator'
// styles
import { globalStyles } from '../../static/styles/global'
import { useTranslation } from 'react-i18next'

const Switchaccount = () => {
  const { t } = useTranslation()
  return (
    <>
      <View
        style={[globalStyles.primaryBgColor, globalStyles.containerBandMenu]}
      >
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
      </View>
      <View style={[globalStyles.flexOne, globalStyles.containerOverlap]}>
        <Card>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs18,
              globalStyles.blackTextColor
            ]}
          >
            {t('switchaccount')}
          </Text>
          <CardSeparator light={true} />
        </Card>
      </View>
    </>
  )
}

export default Switchaccount

const styles = StyleSheet.create({})
